










  import { defineComponent, computed, onMounted, onUnmounted, ref } from 'vue'
  import { NavigationGuardNext, Route } from 'vue-router/types/router'
  import useCurrentInstance from '~/utils/useCurrentInstance'
  import { createIndexCmsComponents } from '~/utils/cmsComponents'
  import { DIVIDER } from '~/mixins/SeoMethodsMixin'
  import useSeoMethods from '~/composables/useSeoMethods'

  export default defineComponent({
    name: 'Index',
    components: {
      OneCmsGridRender: () => import('~/components/molecules/renders/OneCmsGridRender.vue'),
    },

    beforeRouteEnter(_to: Route, _from: Route, next: NavigationGuardNext) {
      return next((vm: any) => {
        vm.$store.dispatch('products/clearSearchAndListing')
      })
    },
    middleware: ['isAuthenticatedOrPlatformOpened'],

    setup() {
      const vm = useCurrentInstance()
      const { DIVIDER, defaultSeoData, structuredSeoTitle } = useSeoMethods(vm)

      const mainComponentClass = 'one-index-page'

      const url = ref<any>({})

      const configuration = computed(() => vm.$store.getters['cms/configuration'])
      const getClient = computed(() => vm.$store.getters['account/getClient'])
      const logo = computed(() => vm.$store.getters['cms/logo'])
      const content = computed(() => configuration.value?.content)
      const loggedUser = computed(() => getClient.value ?? null)

      const availableComponents = createIndexCmsComponents()

      onMounted(() => {
        url.value = window.location
        vm.$plugins.onMounted(mainComponentClass, vm)
      })

      onUnmounted(() => {
        vm.$store.commit('layout/TOGGLE_BACKDROP', false)
        vm.$plugins.onUnmounted(mainComponentClass)
      })

      return {
        mainComponentClass,
        availableComponents,
        content,
        configuration,
        loggedUser,
        logo,
        DIVIDER,
        defaultSeoData,
        structuredSeoTitle,
        url,
      }
    },

    fetch({ store }: any) {
      return store.commit('layout/TOGGLE_BREADCRUMBS', false)
    },

    head() {
      const vm = this as any

      return {
        script: [{
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            publisher: {
              name: vm.configuration?.tenantKey,
            },
            mainEntity: {
              '@type': 'Person',
              email: vm.loggedUser?.invoiceEmail,
              name: vm.loggedUser?.name,
              telephone: vm.loggedUser?.phone,
            },
          },
        }],
        meta: [
          { property: 'og:image', content: vm.logo?.img ?? '', hid: 'og:image' },
          { property: 'og:title', content: vm.structuredSeoTitle(DIVIDER.DOT, [vm.defaultSeoData.title]) ?? '' },
          { property: 'og:description', content: vm.defaultSeoData.description ?? '' },
          { property: 'og:url', content: vm.url.href ?? '' },
          { property: 'og:type', content: 'website' },
          { property: 'og:site_name', content: vm.url.origin ?? '' },
        ],
      }
    },
  })
